<template>
  <div class="score">
    <vue-slider
      ref="slider"
      v-model="internal_value"
      :min="-1"
      :max="31"
      :interval="1"
      :marks="marks"
      drag-on-click
      :height="12"
      :dot-size="18"
      :process="dotsPos => [
        [0, dotsPos[0], { backgroundColor: '#4A90E2' }],
      ]"
      tooltip="always"
    >
      <template v-slot:mark="{ pos, label }">
        <div
          class="custom-mark"
          :class="{'text-white': white}"
          :style="{ left: `${pos}%` }"
        >
          {{ label }}
        </div>
      </template>
      <template v-slot:tooltip="{ value }">
        <div
          :class="{'text-white': white, 'text-primary': !white}"
          style="width: 5em"
        >
          {{ `${value} ${value === 1 ? 'punto' : 'puntos'}` }}
        </div>
      </template>
    </vue-slider>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

export default {
    name: 'ScoreSlider',
    components: { VueSlider },
    props: {
        value: {
            type: Number,
            default: null,
        },
        white: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            internal_value: 0,
        };
    },
    computed: {
        marks() {
            return [0, 5, 10, 15, 20, 25, 30];
        },
    },
    watch: {
        internal_value(newVal) {
            const rangedVal = this.ranged(newVal);
            this.internal_value = rangedVal;
            this.$refs.slider.setValue(rangedVal);
            this.$emit('input', this.internal_value);
        },
        value: {
            handler(newVal) {
                this.internal_value = newVal;
            },
            immediate: true,
        },
    },
    methods: {
        ranged(val) {
            return Math.max(0, Math.min(30, val));
        },
    },
};
</script>

<style>
  .custom-mark {
    position: absolute;
    top: 3px;
    transform: translateX(-50%) translateY(1em);
    white-space: nowrap;
    text-align: center;
    font-size: 0.8em;
    color: gray;
    display: flex;
    justify-content: center;
  }
  .custom-mark::before {
      content: '';
      position: absolute;
      width: 0.1em;
      height: 0.4em;
      background: gray;
      /* TODO: set tick in the middle */
      transform: translateY(-0.28em);
      z-index: -10;
  }
</style>
